import { SCAN_FREQUENCIES, SCAN_STATUSES } from './constants';

import moment from 'moment';

const parseScanFrequencyDays = value => {
    const parsed = Number(value);

    if (!Number.isFinite(parsed)) {
        return undefined;
    }

    // -1 represents unlimited (no frequency restriction).
    if (parsed === -1) {
        return null;
    }

    if (parsed <= 0) {
        return undefined;
    }

    return parsed;
};

const parseMaxDomains = value => {
    const parsed = Number(value);

    if (!Number.isFinite(parsed)) {
        return null;
    }

    // -1 represents unlimited domains.
    if (parsed < 0) {
        return null;
    }

    return parsed;
};

export const resolveScanFrequencyDays = planData => {
    const candidates = [planData?.scanFrequencyDays, planData?.scan_frequency_days];

    const resolved = candidates.map(parseScanFrequencyDays).find(v => v !== undefined);

    return resolved !== undefined ? resolved : SCAN_FREQUENCIES.WEEKLY;
};

export const resolveMaxDomains = planData => {
    const candidates = [planData?.maxDomains, planData?.max_domains];

    return candidates.map(parseMaxDomains).find(value => value !== null) ?? null;
};

const LIMIT_RELEVANT_STATUSES = [
    SCAN_STATUSES.PENDING,
    SCAN_STATUSES.RUNNING,
    SCAN_STATUSES.COMPLETED,
];

/**
 * Returns the most recent scan eligible for rate-limiting (pending, running, or completed).
 * Failed/cancelled scans should not block the user from re-scanning.
 */
export const findLastRelevantScan = (scans = []) =>
    scans.find(scan => LIMIT_RELEVANT_STATUSES.includes(scan.status));

/**
 * Returns true if a scan occurred within the plan's frequency window,
 * meaning another scan should not be allowed yet.
 */
export const isScanWithinFrequencyLimit = (latestScanDate, scanFrequencyDays) => {
    if (!latestScanDate || !scanFrequencyDays) {
        return false;
    }
    const daysSinceLastScan = moment().diff(moment(latestScanDate), 'days', true);
    return daysSinceLastScan < scanFrequencyDays;
};
